export default __webpack_public_path__ + "static/media/a-a-a-de-winter-de-isch-da.736bda44.png";